import {
  Box,
  Button,
  createStyles,
  Group,
  Modal,
  Radio,
  Select,
  Text,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { IconChevronDown } from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import {
  createBillingconsumer,
  createBillingconsumerSkypoint,
  editConsumer,
  editConsumerSkypoint,
  getAllBillingConsumers,
  getAllBillingConsumersSkypoint,
} from "../../../services/billinginvoice";
import { stateZipCodes } from "../../../utils/zipCodes";

const useStyles = createStyles(() => ({
  modalBody: {
    "& .mantine-1q36a81:not(:only-child)": {
      padding: "14px 18px 18px 18px",
      background: "rgb(245, 245, 245)",
    },
  },
  modalHeader: {
    padding: "13px 19px",
  },
  addbox: {
    padding: "35px 24px 47px 24px",
    borderRadius: "12px",
    border: "1px solid #E5E5EA",
    background: "#FFF",
  },

  formRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "16px",
    gap: "17px",
    "@media (max-width:1300px)": {
      // flexDirection: "column",
      // gap: "10px",
    },

    mt19: {
      marginTop: "19px",
    },

    boxtype: {
      display: "flex",
      flexDirection: "row",
    },
  },
  formRowItem: {
    width: "100%",
  },
  itemLabel: {
    fontSize: "14px",
    lineHeight: "normal",
    fontWeight: 500,
    color: "#262626",
    marginBottom: "6px",
    fontFamily: "Inter",
  },
  selectnumber: {
    width: "120px",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  selectbilling: {
    width: "70px",
    padding: "5px 5px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  selecttext: {
    width: "120px",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  line: {
    width: "2px",
    height: "42.011px",
    background: "#525252",
  },

  dflex: {
    display: "flex",
    justifyContent: "space-between",
  },

  flexend: {
    display: "flex",
    justifyContent: "flex-end",
  },

  addbtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "8px",
  },

  boxnumber: {
    display: "flex",
    flexDirection: "row",
    // width:'100%'
    // width: "min-content",
    // justifyContent:'flex-end'
  },

  radiobox: {
    color: "#000",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 500,
  },

  datePicker: {
    width: "40%",
    "& .mantine-InputWrapper-label": {
      marginLeft: 10,
    },
    "& .mantine-DatePickerInput-input": {
      borderRadius: 8,
      border: "1px solid #D4D4D4",
      background: "#FFF",
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F2F4F7",
    },
  },

  itembox: {
    borderRadius: 8,
    border: "1px solid #E5E5E5",
    background: "#FCFCFC",
    padding: "20px",
    width: "100%",
  },

  recurringbox: {
    marginTop: "24px",
    marginBottom: "24px",
    background: "#f2f2f2",
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    display: "flex",
    justifyContent: "center",
    gap: "72px",
    alignItems: "center",
    margin: "auto",
    padding: "6px 13px",
  },

  recuuringselect: {
    marginTop: "20px",
    marginBottom: "20px",
    justifyContent: "center",
    display: "flex",
  },
}));
const bgColor = "#D9D9D9";

const CustomTextInput = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "0px",
      borderRadius: "8px",
      // backgroundColor: bgColor,
      "& input": {
        border: "1px solid " + bgColor,
        backgroundColor: "transparent",
        // border: "none",
        paddingInline: 0,
        width: "100%",
        padding: "10px 14px",
        fontSize: "16px",
        fontWeight: 400,
        fontFamily: "Inter",
        lineHeight: "24px",
        minHeight: "44px",
        boxShadow: "0px 1px 2px 0px #1018280D",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <TextInput {...rest} />
    </div>
  );
};

const CustomSelectBox = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "0px",
      borderRadius: "8px",
      // backgroundColor: bgColor,
      "& input": {
        border: "1px solid " + bgColor,
        // border: "none",
        paddingInline: 0,
        backgroundColor: "transparent",
        padding: "10px 14px",
        minHeight: "44px",
        fontSize: "16px",
        fontFamily: "Inter",
        fontWeight: 400,
        boxShadow: "0px 1px 2px 0px #1018280D",
        lineHeight: "24px",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <Select
        {...rest}
        rightSection={<IconChevronDown color={"#FBAA0D"} size={20} />}
        rightSectionWidth={50}
        styles={{ rightSection: { pointerEvents: "none" } }}
      />
    </div>
  );
};

const SkypointNewconsumer = ({
  isEdit,
  setIsEdit,
  editcustomer,
  setEditcustomer,
  customer,
  createconsumer,
  setCreateConsumer,
}) => {
  // State Hooks
  const [currentStep, setCurrentStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("active");
  const { profile } = useSelector((state) => state?.profile);
  const { classes } = useStyles();

  // Form Hook
  const form = useForm({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      address: "",
      address2: "",
      state: "",
      city: "",
      zipcode: "",
    },
    validate: {
      email: (value) =>
        /^\S+@\S+\.\S+$/.test(value) ? null : "Please enter a valid email",
      phone: (value) =>
        /^[0-9]{10,15}$/.test(value) ? null : "Please enter a valid phone number",
    },
  });

  // Populate form when customer prop is available
  useEffect(() => {
    if (customer) {
      form.setValues({
        name: customer?.name || "",
        email: customer?.email || "",
        phone: customer?.phone || "",
        address: customer?.address || "",
        address2: customer?.address2 || "",
        state: customer?.state || "",
        city: customer?.city || "",
        zipcode: String(customer?.zipcode) || "",
      });
    }
  }, [customer]);

  // Handlers
  const handleStateChange = (value) => {
    form.setFieldValue("state", value);
    // form.setFieldValue("zipcode", "");
  };

  const onSave = async () => {
    if (form.validate().hasErrors) return;
    const values = form.values;

    const emptyField = Object.keys(values).some((key) => {
      // if (key === "address2") return false;
      if (key === "address2" || key === "phone") return false;
      return values[key] === "" || values[key] === null;
    });

    if (emptyField) {
      swal({
        title: "Error",
        text: "All fields are required.",
        icon: "error",
        dangerMode: true,
      });
      return false;
    }

    const selectedState = values.state?.trim();
    const enteredZipCode = values.zipcode?.trim();
    if (selectedState && enteredZipCode) {
      const stateZipCodeEntries = stateZipCodes.filter(
        (entry) => entry.ste_name === selectedState
      );

      const isZipValid = stateZipCodeEntries.some(
        (entry) => entry.zip_code === enteredZipCode
      );

      if (!isZipValid) {
        await swal({
          title: "Invalid Zip Code",
          text: `The zip code you entered is not valid for ${selectedState}. Please enter a valid zip code.`,
          icon: "warning",
          dangerMode: true,
        });
        return;
      }
    }

    let payload = {
      ...values,
      contractor: profile.user.id,
      status,
    };

    let editPayload = {
      ...values,
      contractor: profile.user.id,
      status,
      id: customer.id,
      lastPaymentDate: customer?.lastPaymentDate,
      totalReceivables: customer?.totalReceivables,
    };

    setLoading(true);
    try {
      if (isEdit) {
        const res = await editConsumerSkypoint(editPayload);
        if (res.status === 200) {
          getAllBillingConsumersSkypoint();
          swal({
            icon: "success",
            title: "Provider Updated",
            text: "The provider details have been successfully updated.",
            dangerMode: false,
          });
          handleClose();
        }
      } else {
        const res = await createBillingconsumerSkypoint(payload);
        if (res.status === 200) {
          getAllBillingConsumersSkypoint();
          swal({
            icon: "success",
            title: "Provider Created",
            text: "A new provider has been added to the system.",
            dangerMode: false,
          });
          handleClose();
        }
      }
    } catch (error) {
      console.error("Error in saving customer:", error);
      swal({
        icon: "error",
        title: "Error",
        text: "Something went wrong. Please try again.",
        dangerMode: true,
      });
    } finally {
      setLoading(false);
    }
  };
  const handleClose = () => {
    form?.reset();
    setIsEdit("");
    setCreateConsumer(false);
    setEditcustomer(false);
  };

  const renderContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <>
            <form>
              <Box className={classes.addbox}>
                <div className={classes.formRow}>
                  <Box className={classes.formRowItem}>
                    <Text className={classes.itemLabel}>Provider Name</Text>
                    <Box className={classes.boxnumber}>
                      <CustomTextInput
                        id="invoice-Number"
                        required
                        size="sm"
                        placeholder={"Enter Provider Name"}
                        withAsterisk
                        {...form.getInputProps("name")}
                      />
                    </Box>
                  </Box>

                  <Box className={classes.formRowItem}>
                    <Text className={classes.itemLabel}>Provider Email</Text>
                    <Box className={classes.boxnumber}>
                      <CustomTextInput
                        id="invoice-Number"
                        required
                        size="sm"
                        placeholder={"Enter Provider Email"}
                        withAsterisk
                        {...form.getInputProps("email")}
                        type="email"
                      />
                    </Box>
                  </Box>
                </div>

                <div className={classes.formRow}>
                  <Box className={classes.formRowItem}>
                    <Text className={classes.itemLabel}>Provider Phone</Text>
                    <Box className={classes.boxnumber}>
                      <CustomTextInput
                        id="invoice-Number"
                        required
                        size="sm"
                        withAsterisk
                        placeholder={"Enter Provider Phone"}
                        {...form.getInputProps("phone")}
                        type="number"
                      />
                    </Box>
                  </Box>

                  <Box className={classes.formRowItem}>
                    <Text className={classes.itemLabel}>Provider City</Text>
                    <Box className={classes.boxnumber}>
                      <CustomTextInput
                        id="invoice-Number"
                        required
                        size="sm"
                        placeholder={"Enter Provider City"}
                        withAsterisk
                        {...form.getInputProps("city")}
                      />
                    </Box>
                  </Box>
                </div>

                <div className={classes.formRow}>
                  <Box className={classes.formRowItem}>
                    <Text className={classes.itemLabel}>Provider Address</Text>
                    <Box className={classes.boxnumber}>
                      <CustomTextInput
                        id="invoice-Number"
                        required
                        placeholder={"Enter Provider Address"}
                        size="sm"
                        withAsterisk
                        {...form.getInputProps("address")}
                      />
                    </Box>
                  </Box>
                </div>
                <div className={classes.formRow}>
                  <Box className={classes.formRowItem}>
                    <Text className={classes.itemLabel}>
                      Provider Address 2
                    </Text>
                    <Box className={classes.boxnumber}>
                      <CustomTextInput
                        id="invoice-Number"
                        required
                        size="sm"
                        placeholder={"Enter Provider Address"}
                        withAsterisk
                        {...form.getInputProps("address2")}
                      />
                    </Box>
                  </Box>
                </div>

                <div className={classes.formRow}>
                  <Box className={classes.formRowItem}>
                    <Text className={classes.itemLabel}>Provider State</Text>

                    <CustomSelectBox
                      id="state"
                      size="sm"
                      withAsterisk
                      data={Array.from(
                        new Set(stateZipCodes?.map((obj) => obj.ste_name))
                      )
                        ?.sort()
                        ?.map((ste_name) => ({
                          value: ste_name,
                          label: ste_name,
                        }))}
                      {...form.getInputProps("state")}
                      placeholder={"Select State"}
                      searchable
                      onChange={handleStateChange}
                    />
                  </Box>

                  <Box className={classes.formRowItem}>
                    <Text className={classes.itemLabel}>Provider Zip Code</Text>

                    {/* <CustomSelectBox
                      id="zip-code"
                      type="number"
                      size="sm"
                      placeholder={"Select Zip Code"}
                      withAsterisk
                      disabled={!form?.values?.state}
                      data={
                        form?.values?.state
                          ? stateZipCodes
                              ?.filter(
                                (obj) => obj?.ste_name === form?.values?.state
                              )
                              ?.map((obj) => ({
                                value: obj?.zip_code,
                                label: obj?.zip_code,
                              }))
                          : []
                      }
                      {...form.getInputProps("zipcode")}
                      searchable
                    /> */}

                    <CustomTextInput
                      id="zip-code"
                      type="number"
                      // label={"Taxonomy/Speciality"}
                      size="sm"
                      // type="number"
                      placeholder={"Enter Zip Code"}
                      // {...form.getInputProps("medicationName")}
                      withAsterisk
                      {...form.getInputProps("zipcode")}
                      // disabled={true}
                      // value={selectedPayer?.payerid}
                    />
                  </Box>
                </div>

                <Box
                  style={{ marginTop: "40px", marginBottom: "0px" }}
                  className={classes.formRow}
                >
                  <Button
                    variant="filled"
                    onClick={handleClose}
                    c={"#000"}
                    radius={"8px"}
                    className={classes.formRowItem}
                    style={{
                      background: "#F5F5F5",
                      height: "fit-content",
                      padding: "16px",
                      fontSize: "18px",
                      fontWeight: "600",
                    }}
                    size="md"
                  >
                    Cancel
                  </Button>

                  <Button
                    onClick={onSave}
                    variant="filled"
                    className={classes.formRowItem}
                    c={"#000"}
                    radius={"8px"}
                    size="md"
                    style={{
                      height: "fit-content",
                      padding: "16px",
                      fontSize: "18px",
                      fontWeight: "600",
                    }}
                    color="yellow"
                    loading={loading}
                  >
                    {isEdit ? "Update Provider" : "Create Provider"}
                  </Button>
                </Box>
              </Box>
            </form>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <Modal
      centered
      size={1000}
      shadow="md"
      radius={"lg"}
      zIndex={1000}
      onClose={handleClose}
      overlayProps={{ blur: 3 }}
      style={{ background: "#F5F5F5" }}
      opened={createconsumer || editcustomer}
      classNames={{ header: classes.modalHeader }}
      className={classes.modalBody}
      title={
        <Text fz={"24px"} ff={"Inter"} fw={700}>
          {isEdit ? "Edit Provider" : "Add Provider"}
        </Text>
      }
    >
      <Box>{renderContent()}</Box>
    </Modal>
  );
};

export default SkypointNewconsumer;
